module.exports = __webpack_public_path__ + "static/img/GYWM-24.8dca4fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutUs/GYWM-24.jpg
// module id = dEw1
// module chunks = 1